import { jsx } from 'react/jsx-runtime';
import { useMemo, createContext, useContext } from 'react';
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
const MsgPolycardContextError = 'usePolycardContext must be used within a PolycardContext';
const MsgCardContextError = 'useCardContext must be used within a useCardContext';
const MsgThousandDecimalError = 'The Thousand Separator or Decimal Separator is not defined in Polycard';
const Devices = ['mobile', 'tablet', 'desktop'];
const isMobile = device => {
  if (device && Object.values(Devices).includes(device)) return device === 'mobile';
  return false;
};
const isTablet = device => {
  if (device && Object.values(Devices).includes(device)) return device === 'tablet';
  return false;
};
const polycardContext = /*#__PURE__*/createContext(undefined);
const PolycardContext = _ref => {
  let {
    contextValue,
    deviceType,
    actionCallbacks,
    children,
    thousandSeparator,
    decimalSeparator,
    countPreloadImages,
    isNavigableToVariation,
    lowEnd,
    targetLink
  } = _ref;
  const value = useMemo(() => _extends({}, contextValue, {
    deviceType,
    isMobile: isMobile(deviceType),
    isTablet: isTablet(deviceType),
    actionCallbacks,
    thousandSeparator,
    decimalSeparator,
    countPreloadImages,
    isNavigableToVariation: isMobile(deviceType) || isNavigableToVariation,
    lowEnd,
    targetLink,
    card_size: (contextValue == null ? void 0 : contextValue.card_size) || 'large'
  }), [contextValue, deviceType, actionCallbacks, thousandSeparator, decimalSeparator, countPreloadImages, isNavigableToVariation, targetLink, lowEnd]);
  return jsx(polycardContext.Provider, {
    value: value,
    children: children
  });
};
function usePolycardContext() {
  const context = useContext(polycardContext);
  if (context === undefined) {
    throw new Error(MsgPolycardContextError);
  }
  return context;
}
export { Devices as D, MsgCardContextError as M, PolycardContext as P, _extends as _, MsgThousandDecimalError as a, usePolycardContext as u };
